import { useEffect } from "react";
import { useNurseryConfig } from "@/hooks/useNurseryConfig";
import { setActiveOperatingHours } from "@/lib/shiftTypes";

/**
 * Reads the current nursery's configured operating hours and pushes them
 * into the shiftTypes module so all classification helpers (Rota legend,
 * shift colours, exports, reports) use the nursery's actual times rather
 * than hardcoded fallbacks. Returns the same values so components that
 * need them directly (e.g. RotaLegend for labels) can read them.
 */
export function useOperatingHours() {
  const { data: config } = useNurseryConfig();

  const open = config?.earliest_session_start?.slice(0, 5) || "07:30";
  const close = config?.latest_session_end?.slice(0, 5) || "18:30";
  const opsOpen = config?.earliest_shift_start?.slice(0, 5) || "07:00";
  const opsClose = config?.latest_shift_end?.slice(0, 5) || "20:00";

  useEffect(() => {
    setActiveOperatingHours({ open, close, opsOpen, opsClose });
  }, [open, close, opsOpen, opsClose]);

  return { open, close, opsOpen, opsClose };
}
